import type { Decimal } from 'decimal.js';

import type { PaymentMethodTotals } from './paymentTotals';

export const getPointsTotals = (
  totalAmount: Decimal,
  { voucher, creditCard, creditNote, qantasGroupCreditVoucher, points }: PaymentMethodTotals,
) => {
  const pointsInCash = totalAmount.minus(voucher).minus(creditNote).minus(qantasGroupCreditVoucher).minus(creditCard);

  const pointsPayPercentage = points.greaterThan(0) ? pointsInCash.dividedBy(totalAmount).times(100).toFixed(2) : 0;

  return {
    pointsInCash,
    pointsPayPercentage,
  };
};
